import app from '../../scripts/app';
import template from './price-limit.jade';

import priceLimitValidator from './price-limit-validator';

app.directive('cianAfPriceLimit', [
  'priceLimitService',
  '$rootScope',
  (priceLimitService, $rootScope) => ({
    template,
    scope: {},
    bindToController: {
      ad: '=',
    },
    controller() {
      $rootScope.$on(priceLimitService.events.LIMIT_UPDATED, (event, limitInfo) => {
        this.limitInfo = limitInfo;
        this.isVisible = this.limitInfo.priceLimit > 0;
      });
    },
    controllerAs: 'priceLimit',
  }),
]);
app.directive('cianAfPriceLimitValidator', priceLimitValidator);
